// extracted by mini-css-extract-plugin
export default {"container":"style_container__icxkp","textHeader":"style_textHeader__lFonb","text":"style_text__iN8P3"};